import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { authService } from '../services/apiService';
import './LoginPage.css';
import { toast } from 'react-toastify';

const LoginPage = () => {
    const [cnpj, setCnpj] = useState('');
    const [usuario, setUsuario] = useState('marcel@mpi.com.br');
    const [senha, setSenha] = useState('');
    const [origem, setOrigem] = useState('0');
    const [erro, setErro] = useState('');
    const [carregando, setCarregando] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    // Capturar o CNPJ da URL quando o componente montar
    useEffect(() => {
        const params = new URLSearchParams(location.search);

        const cnpjParam = params.get('cnpj');
        const codigoParam = params.get('codigo');
        const origemParam = params.get('origem');

        if (cnpjParam) {
            const cnpjFormatado = cnpjParam.replace(
                /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
                "$1.$2.$3/$4-$5"
            );

            setCnpj(cnpjFormatado);
        }

        if (codigoParam) {
            setSenha(codigoParam);
        }

        if (origemParam) {
            setOrigem(origemParam);
        }

    }, [location]);

    // Função para remover formatação do CNPJ antes de enviar para a API
    const limparCnpj = (cnpjFormatado) => {
        return cnpjFormatado.replace(/[^\d]/g, '');
    };

    // Função para tratar o login
    const handleLogin = async (e) => {
        e.preventDefault();
        setErro('');

        // Validações básicas
        if (!cnpj || !usuario || !senha) {
            setErro('Todos os campos são obrigatórios');
            return;
        }

        try {
            setCarregando(true);

            authService.logout();

            // Chamar o serviço de autenticação
            const retorno = await authService.login(
                limparCnpj(cnpj),
                usuario,
                senha,
                origem
            );

            if (Number(retorno.id) === 0) {
                toast.warning('Dados não conferem...');
                alert('Dados não confere.')
            } else {
                localStorage.setItem('cnpj', cnpj);
                alert('Login efetuado com sucesso...')
                // Redirecionar para a página de documentos
                navigate('/documentos');
            }
        } catch (error) {
            console.error('Erro ao fazer login:', error);

            // Tratar diferentes tipos de erro
            if (error.response) {
                // A requisição foi feita e o servidor respondeu com um status fora do intervalo 2xx
                if (error.response.status === 401) {
                    setErro('Usuário ou senha inválidos');
                } else if (error.response.status === 404) {
                    setErro('CNPJ não encontrado');
                } else {
                    setErro('Erro ao acessar o sistema. Tente novamente mais tarde.');
                }
            } else if (error.request) {
                // A requisição foi feita mas não recebeu resposta
                setErro('Não foi possível conectar ao servidor. Verifique sua conexão.');
            } else {
                // Algo aconteceu na configuração da requisição que acionou um erro
                setErro('Erro ao processar sua solicitação.');
            }
        } finally {
            setCarregando(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <h1>Portal de Documentos</h1>
                    <p>Acesse seus boletos e notas fiscais</p>
                </div>

                <form onSubmit={handleLogin} className="login-form">
                    <div className="form-group">
                        <label htmlFor="cnpj">CNPJ</label>
                        <input
                            type="text"
                            id="cnpj"
                            value={cnpj}
                            onChange={(e) => setCnpj(e.target.value)}
                            placeholder="XX.XXX.XXX/XXXX-XX"
                            disabled={cnpj !== ''} // Desabilita o campo se já vier preenchido da URL
                            className="form-input"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="senha">Codigo fornecido no acesso</label>
                        <input
                            id="senha"
                            value={senha}
                            onChange={(e) => setSenha(e.target.value)}
                            placeholder="Informe o codigo"
                            className="form-input"
                            autoComplete="current-password"
                        />
                    </div>

                    {erro && <div className="erro-mensagem">{erro}</div>}

                    <button
                        type="submit"
                        className="login-button"
                        disabled={carregando}
                    >
                        {carregando ? 'Entrando...' : 'Entrar'}
                    </button>
                </form>

            </div>
        </div>
    );
};

export default LoginPage;